module.exports = __webpack_public_path__ + "static/scale-model-of-tallahassee-florida-f6203feb85603f11eab18084ebec4d34.png";